import { render, staticRenderFns } from "./MoreRestaurantsCompaniesChart.vue?vue&type=template&id=d5254d4c"
import script from "./MoreRestaurantsCompaniesChart.vue?vue&type=script&lang=js"
export * from "./MoreRestaurantsCompaniesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports